import { IconFileText, IconMessageChatbot, IconRobot, IconSettings } from '@tabler/icons-react'

export const BASIC_TOP_ROUTES = [
  { path: '/assistants', label: 'Chat', icon: IconMessageChatbot, hint: 'Chat with Owlbert' },
  { path: '/assistants-config', label: 'Assistants', icon: IconRobot, hint: 'Create and edit assistants' },
  { path: '/user-documents', label: 'Documents', icon: IconFileText, hint: 'Documents' },
] as const

/** Retained for the (now nav-less) /settings route — sign-in, workspace, LLMs still live there. */
export const SETTINGS_NAV = {
  path: '/settings',
  label: 'Settings',
  icon: IconSettings,
  hint: 'Settings',
} as const
